var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.35 7.88125C11.3875 7.88125 12.225 8.71875 12.225 9.75625C12.225 10.7937 11.3875 11.6313 10.35 11.6313C9.3125 11.6313 8.475 10.7937 8.475 9.75625C8.475 8.71875 9.3125 7.88125 10.35 7.88125ZM16.6 16.6313C17.6375 16.6313 18.475 17.4688 18.475 18.5063C18.475 19.5438 17.6375 20.3813 16.6 20.3813C15.5625 20.3813 14.725 19.5438 14.725 18.5063C14.725 17.4688 15.5625 16.6313 16.6 16.6313ZM8.9875 20.3813L7.225 18.6188L17.9625 7.88125L19.725 9.64375L8.9875 20.3813ZM21.7875 2.69375L22.55 7.51875L26.9375 9.75625L24.725 14.1313L26.95 18.5063L22.525 20.7438L21.7625 25.5688L16.9 24.8063L13.4375 28.2687L9.9625 24.7563L5.1375 25.5562L4.3625 20.6938L0 18.4688L2.225 14.0938L0.0125 9.75625L4.4 7.49375L5.1625 2.71875L10 3.50625L13.475 0L16.925 3.45625L21.7875 2.69375ZM23.6 10.8438L20.35 9.13125L19.725 5.51875L16.1 6.04375L13.475 3.50625L10.85 6.04375L7.225 5.51875L6.6 9.13125L3.35 10.8438L4.975 14.1313L3.35 17.4188L6.6 19.1313L7.225 22.7437L10.85 22.2188L13.475 24.7563L16.1 22.2188L19.725 22.7437L20.35 19.1313L23.6 17.4188L21.975 14.1313L23.6 10.8438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecent);
export default __webpack_public_path__ + "static/media/precent.abd9c9feea0c874815c85564c06ad6dc.svg";
export { ForwardRef as ReactComponent };